import React  from 'react';
import styled from 'styled-components';

const StyledPrices = styled.div`
  border-bottom: 1px solid rgba(var(--greyr), 0.3);
  overflow: hidden;
  position: relative;
background-color: var(--white);
z-index: 3;
  .marquee-container {
    display: flex;
    width: max-content;
    animation: scroll 90s linear infinite;
  }

  .marquee-content {
    display: flex;
    flex-direction: row;
    gap: 40px;
    padding: 20px 40px;
    flex-shrink: 0;
  }

  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }

  .ticker {
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: center;
    font-size: 11px;
    white-space: nowrap;

    p.up { color: #007a3e; }
    p.down { color: #c62828; }
  }
`;


const prices = [
  {"ticker":"BNLB","price":"287.50","direction":"up","change":"1.0%"}, {"ticker":"FOTT","price":"326.87","direction":"down","change":"0.8%"}, {"ticker":"MIOB","price":"197.72","direction":"up","change":"1.2%"}, {"ticker":"ADGG","price":"323.10","direction":"down","change":"1.4%"}, {"ticker":"USLS","price":"12.20","direction":"down","change":"0.2%"}, {"ticker":"XKNY","price":"171.34","direction":"down","change":"1.5%"}, {"ticker":"ZQOV","price":"488.22","direction":"up","change":"1.9%"}, {"ticker":"JHWP","price":"225.48","direction":"up","change":"0.9%"}, {"ticker":"RWBI","price":"312.66","direction":"down","change":"0.7%"}, {"ticker":"KQBE","price":"143.77","direction":"up","change":"0.3%"}, {"ticker":"VYXF","price":"155.01","direction":"down","change":"0.4%"}, {"ticker":"EJGO","price":"248.90","direction":"down","change":"1.0%"}, {"ticker":"YVMA","price":"362.71","direction":"up","change":"1.8%"}, {"ticker":"PLQW","price":"273.50","direction":"up","change":"1.6%"}, {"ticker":"NRDS","price":"420.54","direction":"down","change":"1.1%"}, {"ticker":"BTRJ","price":"499.33","direction":"up","change":"0.8%"}, {"ticker":"QXHD","price":"191.60","direction":"down","change":"0.6%"}, {"ticker":"OMKP","price":"473.77","direction":"up","change":"1.7%"}, {"ticker":"LZHC","price":"456.90","direction":"down","change":"1.3%"}, {"ticker":"AFVM","price":"389.14","direction":"up","change":"1.5%"}, {"ticker":"JZKL","price":"315.80","direction":"down","change":"0.9%"}, {"ticker":"SDPU","price":"448.07","direction":"up","change":"0.4%"}, {"ticker":"GQHX","price":"158.33","direction":"down","change":"0.5%"}, {"ticker":"TYVN","price":"328.22","direction":"up","change":"1.3%"}, {"ticker":"WOSQ","price":"492.66","direction":"up","change":"1.8%"}, {"ticker":"HVNM","price":"493.98","direction":"down","change":"1.7%"}, {"ticker":"ZBWR","price":"307.61","direction":"down","change":"0.6%"}, {"ticker":"QYLF","price":"480.77","direction":"down","change":"1.0%"}, {"ticker":"KZVC","price":"227.73","direction":"up","change":"1.4%"}, {"ticker":"XUJP","price":"272.41","direction":"down","change":"1.3%"}, {"ticker":"MZAF","price":"325.51","direction":"up","change":"1.0%"}, {"ticker":"CPTH","price":"381.44","direction":"up","change":"0.8%"}, {"ticker":"HMBW","price":"36.70","direction":"up","change":"1.1%"}, {"ticker":"VJER","price":"295.12","direction":"down","change":"1.5%"}, {"ticker":"OLPF","price":"443.33","direction":"down","change":"1.6%"}, {"ticker":"ARQJ","price":"188.40","direction":"up","change":"1.9%"}, {"ticker":"DNWH","price":"161.20","direction":"down","change":"1.2%"}, {"ticker":"GIYH","price":"328.50","direction":"up","change":"1.7%"}, {"ticker":"YUHF","price":"121.07","direction":"up","change":"0.4%"}, {"ticker":"FBQM","price":"490.11","direction":"down","change":"0.8%"}, {"ticker":"KXHT","price":"397.45","direction":"up","change":"1.8%"}, {"ticker":"JLVN","price":"89.18","direction":"down","change":"0.4%"}, {"ticker":"ETRU","price":"339.74","direction":"up","change":"1.7%"}, {"ticker":"ZVKS","price":"223.90","direction":"down","change":"1.6%"}, {"ticker":"QWRD","price":"14.29","direction":"down","change":"1.2%"}, {"ticker":"MSQF","price":"72.44","direction":"up","change":"1.5%"}, {"ticker":"HKFI","price":"270.88","direction":"up","change":"1.4%"}, {"ticker":"BDNO","price":"323.77","direction":"down","change":"1.0%"}, {"ticker":"UVRC","price":"310.11","direction":"up","change":"1.1%"}, ];

const Prices: React.FC = () => {
  return (
  <StyledPrices>
       <div className="marquee-container">
        {[...Array(2)].map((_, index) => (
          <div key={index} className="marquee-content">
            {prices.map((t, i) => (
              <div key={`${index}-${i}`} className="ticker">
                <b className="sans">{t.ticker}</b>
                <span>{t.price}</span>
                <p className={t.direction}>
                  {t.direction === 'up' ? '+' : '-'} {t.change}
                </p>
              </div>
            ))}
          </div>
        ))}
      </div>
  </StyledPrices>
  );
};

export default Prices;
